import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DadosContratosModel } from './../model/dados-contrato.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import Utils from '../utils/utils';


@Component({
  selector: 'app-contrato-amplo-pf',
  templateUrl: './contrato-amplo-pf.component.html',
  styleUrls: ['./contrato-amplo-pf.component.css']
})
export class ContratoAmploPfComponent implements OnInit {

  // @Input() nomeperfil: string; // decorate the property with @Input()
  @Input() infoContratos: DadosContratosModel;
  public inscricaoFormatada: string;

  ngOnInit(){
    this.formatarInscricao();
  }

  public formatarInscricao() {

    const tipoInsc = this.infoContratos.tipoInscricao;
    this.inscricaoFormatada = Utils.formatarInscricao(this.infoContratos.inscricao, tipoInsc);
    switch (tipoInsc) {
      case '3':
        this.inscricaoFormatada = Utils.mascararCPF(this.inscricaoFormatada);
        break;
      case '2':
        this.inscricaoFormatada = Utils.mascararCEI(this.inscricaoFormatada);
    }
  }

}
